<app-loader *ngIf="isLoading"></app-loader>
<div class="signupform">
  <form [formGroup]="signUpForm">
    <h2 class="">
      <strong>{{ "SIGNUP.TITLE" | translate }}</strong>
    </h2>
    <div class="mt-3 form-group mb-3">
      <label for="name" class="q-form-label">{{ "SIGNUP.NAME" | translate }} </label><span class="text-danger">*</span>
      <input type="text" #testInput autofocus="true" autocomplete="off" class="q-form-input form-control q-form-control"
        formControlName="name" maxlength="50" (keydown)="removeSpace($event, 'name')"
        (keypress)="keyPressAlphaNumericWithCharacters($event, 'name');onlyAlphabets($event)"
        [ngClass]="{ 'is-invalid': isSubmitted && f['name'].errors }"
        placeholder="{{ 'SIGNUP.ENTERURNAME' | translate }}" />
    </div>

    <div class="mt-2 form-group mb-3">
      <div class="d-flex mw-340">
        <label for="email" class="q-form-label">{{ "SIGNUP.EmailId" | translate }} </label>
        <span class="text-danger">*</span>&nbsp;
        <span style="font-size:12px; font-weight:400; position: relative; top:3px;">{{ "SIGNUP.EMAILWITHQHACCOUNT" |
          translate }} </span>
        <div *ngIf="emailVerified" class="d-block d-md-none" (click)="clearEmail()">
          <img class="cursor-pointer" src="assets/images/pen.svg" alt="" />
        </div>
      </div>
      <div>
        <div class="d-flex flex-wrap align-items-baseline">
          <input type="text" autocomplete="off" class="q-form-input form-control q-form-control pr-40"
            formControlName="email" minlength="10" maxlength="100" (keypress)="removeSpace($event, 'email')"
            (keypress)="keyPressAlphaNumericWithCharacters($event, 'email')"
            placeholder="{{ 'SIGNUP.EmailEnter' | translate }}"
            (keyup)="clearfield($event);verifyEmailwithActivation()" />

          <div class="signup-showpwdIcon" *ngIf="emailVerified">
            <img src="../../../assets/images/verified.png" alt="" />
          </div>
          <button *ngIf="!emailVerified && !isSentOTP && f['email'].value?.length != 0 && !isInvalidEmail" type="button"
            [ngClass]="
              signUpForm.controls['email'].invalid && timeOver && !isInvalidEmail 
                ? 'border-0 bg-white cursor-not-allowed shadow-none disabledSendOtp outline-none p-0 ms-2 mt-2 mt-xl-0'
                : 'border-0 bg-white cursor-pointer shadow-none sendOTp outline-none p-0 ms-2 mt-2 mt-xl-0'
            " [disabled]="signUpForm.controls['email'].invalid && timeOver && !isInvalidEmail" (click)="emailOTP()">
            {{"SIGNUP.SENDOTP"|translate}}
          </button>

          <div *ngIf="emailVerified" class="emailEditOnSIgnup d-none d-md-block" (click)="clearEmail()">
            <img class="cursor-pointer" src="assets/images/pen.svg" alt="" />
          </div>
        </div>
        <ng-container *ngIf="isSentOTP && timeOver" class="mt-2">
          <small>
            {{ "RESENDOT.RESENDOTPIN" | translate }}
            {{ durationMinutes }}</small>
        </ng-container>
        <div class="d-flex mt-3 mw-382" *ngIf="!timeOver && isSentOTP">
          <span>{{ "LOGIN.DIDNTRECEIVEOTP" | translate }}</span>
          <button type="button" style="cursor: pointer; height: 0px !important" [ngClass]="
              signUpForm.controls['email'].invalid && timeOver
                ? 'border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2 cursor-not-allowed'
                : 'border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2'
            " [disabled]="signUpForm.controls['email'].invalid" (click)="emailOTP()">
            {{ "LOGIN.RESEND" | translate }}
          </button>
        </div>
      </div>
    </div>

    <ng-container *ngIf="isSentOTP">
      <div class="d-flex flex-wrap align-items-center">
        <div class="charClass me-2 mb-2">
          {{ emailResponse }}
        </div>
        <div class="me-2 mb-2">
          <ng-otp-input (onInputChange)="onOtpChange($event)" #ngOtpInput
            [config]="{ length: 4, allowNumbersOnly: true }">
          </ng-otp-input>
        </div>
        <div>
          <button type="button" class="q-form-white-submit mb-2" [ngClass]="
              !otpValue
                ? 'q-form-white-submit mb-0 cursor-not-allowed'
                : 'q-form-white-submit mb-0'
            " [disabled]="!otpValue" (click)="submitOTP()">
            {{ "SIGNUP.SUBMITOTP" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="emailErrorMessage">
      <p class="errMessage mb-0">{{ emailErrorMessage }}</p>
    </ng-container>
    <ng-container *ngIf="isInvalidEmail">
      <p class="errMessage mw-340" style="margin-top:-10px !important">
        {{ invalidEmailStatMsg!=''?invalidEmailStatMsg: "SIGNUP.ENTERVALIDEMAILID" | translate }}
      </p>
    </ng-container>

    <div class="mt-2 form-group mb-3">
      <label for="phone number" class="q-form-label">{{ "SIGNUP.MobileNumber" | translate }}
      </label>
      <br />
      <ngx-intl-tel-input [cssClass]="'form-control q-form-control'" [preferredCountries]="[
          CountryISO.UnitedStates,
          CountryISO.UnitedKingdom
        ]" [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
        customPlaceholder="{{'SIGNUP.ENTERYOURMBLNO'|translate}}" [searchCountryField]="[
          SearchCountryField.Iso2,
          SearchCountryField.Name
        ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15" type="number"
        [phoneValidation]="false" name="mobileNo" formControlName="mobileNo"
        (keypress)="keyPressAlphaNumericWithCharacters($event, 'mobile')" (keypress)="removeSpace($event, 'mobile')"
        (ngModelChange)="onFocusOutMobile($event)"></ngx-intl-tel-input>
      <ng-container *ngIf="mobileNoWrong">
        <p class="errMessage">{{ "MANAGEDEVICE.MINANDMAX8" | translate }}</p>
      </ng-container>
    </div>

    <div class="mt-2 form-group mb-3">
      <label for="password" class="q-form-label">{{ "SIGNUP.PASSWORD" | translate }} </label><span
        class="text-danger">*</span>
      <div class="dropdown info-dropdown cursor-pointer">
        <img src="assets/images/information.svg" alt="" class="ms-2" />
        <div class="dropdown-content">
          <div class="d-flex flex-column">
            <div class="fw-bold">
              {{ "LOGIN.PASSWORDCRITERIA" | translate }}
            </div>
            <div>1. {{ "LOGIN.PASSWORDCONTAINS" | translate }}</div>
            <div>2. {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}</div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <input [type]="password" autocomplete="off" formControlName="password" (keyup)="passwordVerify()"
          (keypress)="removeSpace($event, 'pass')" class="q-form-input form-control q-form-control pr-40"
          placeholder="{{ 'SIGNUP.ENTERYOURPASSWORD' | translate }}" />

        <div class="signup-showpwdIcon" (click)="onClick('pwd')">
          <img src="../../../assets/images/hidepwd.png" alt="" *ngIf="!newPassword && f['password'].value?.length != 0"
            class="cursor-pointer" />
          <img src="../../../assets/images/showpwd.png" alt="" *ngIf="newPassword && f['password'].value?.length != 0"
            class="cursor-pointer" />
        </div>
      </div>
      <div class="mw-340">
        <p class="errMessage" *ngIf="signUpForm.controls['password'].errors">
          {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}<br />
        </p>
      </div>
    </div>
    <div class="mt-2 form-group mw-340 mb-3">
      <label for="confirmPassword" class="q-form-label">{{ "SIGNUP.CONFIRMPASSWORD" | translate }} </label><span
        class="text-danger">*</span>
      <div class="dropdown info-dropdown cursor-pointer">
        <img src="assets/images/information.svg" alt="" class="ms-2" />
        <div class="dropdown-content">
          <div class="d-flex flex-column">
            <div class="fw-bold">
              {{ "LOGIN.PASSWORDCRITERIA" | translate }}
            </div>
            <div>1. {{ "LOGIN.PASSWORDCONTAINS" | translate }}</div>
            <div>2. {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}</div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <input [type]="passwords" autocomplete="off" (keyup)="onFocusOut()" (keypress)="removeSpace($event, 'pass')"
          formControlName="confirmPassword" class="q-form-input form-control q-form-control pr-40"
          placeholder="{{ 'SIGNUP.ENTERYOURPASSWORD' | translate }}" />
        <div class="signup-showpwdIcon" (click)="onClick('confPwd')">
          <img src="../../../assets/images/hidepwd.png" alt=""
            *ngIf="!confPassword && f['confirmPassword'].value?.length != 0" class="cursor-pointer" />

          <img src="../../../assets/images/showpwd.png" alt=""
            *ngIf="confPassword && f['confirmPassword'].value?.length != 0" class="cursor-pointer" />
        </div>
      </div>
      <ng-container *ngIf="pwdNotMatch">
        <p class="errMessage">
          {{ "SIGNUP.CONFIRMPASSWORDDOESNOTMATCH" | translate }}
        </p>
      </ng-container>
    </div>
    <div class="d-flex form-group mb-3">
      <label class="terms-checkbox">
        <input type="checkbox" class="form-control q-form-control" formControlName="acceptTerms" [ngClass]="{
            'is-invalid': isSubmitted && f['acceptTerms'].errors
          }" />
        <span class="checkmark"></span>
      </label>
      <div class="agree-txt" data-toggle="tooltip" i18n-title
        title='{{ "SIGNUP.BySignIning" | translate }}{{ "SIGNUP.LicenceAgreement" | translate }}{{ "SIGNUP.AND" | translate }}{{ "SIGNUP.PrivacyPolicy" | translate }}'>
        {{ "SIGNUP.BySignIning" | translate }} <br />
        <span>
          <a class="org-clr" rel="noopener" href="https://www.quickheal.co.in/eula" target="_blank">
            {{ "SIGNUP.LicenceAgreement" | translate }}
          </a>
          <span class="text-black mx-1">{{ "SIGNUP.AND" | translate }}</span>
          <a class="org-clr" href="https://www.quickheal.co.in/privacy-policy" target="_blank" rel="noopener">
            {{ "SIGNUP.PrivacyPolicy" | translate }}</a>
        </span>
      </div>
    </div>
    <!-- {{ !signUpForm.valid ||
    !isProducyKeyVerified ||
    !emailVerified ||
    pwdNotMatch}}
    =={{ !signUpForm.valid}}={{!isProducyKeyVerified }}={{!emailVerified }}={{pwdNotMatch}} -->
    <div>
      <button (click)="onSignUp($event)" [disabled]=" 
          !signUpForm.valid ||
          !emailVerified ||
          pwdNotMatch || mobileNoWrong
        " [ngClass]="
          !signUpForm.valid ||
          !emailVerified ||
          pwdNotMatch || mobileNoWrong
            ? 'q-invalid-button'
            : 'submit-btn bg-orgclr'
        ">
        {{ "SIGNUP.CreateAccount" | translate }}
      </button>
    </div>
  </form>
  <div class="d-flex align-items-center my-3">
    <div class="line"></div>
    <div class="or-text" data-toggle="tooltip" i18n-title title='{{ "LOGIN.ORCONTINUEWITH" | translate }}'>{{
      "LOGIN.ORCONTINUEWITH" | translate }}</div>
    <div class="line"></div>
  </div>

  <div class="text-center mt-4">
    <div class="d-flex align-items-center mb-2">
      <div class="white-line"></div>
      <div class="q-icon-box cursor-pointer" (click)="signUpWIthGoogle()">
        <img src="assets/images/googleimg.svg" alt="google" />
      </div>
      <div class="white-line"></div>
      <!-- <div class="q-icon-box cursor-pointer" (click)="signUpWIthFacebook()">
        <img src="assets/images/fbimg.svg" class="" alt="facebook" />
      </div> -->
    </div>
    <div class="d-flex">
      <div data-toggle="tooltip" i18n-title title='{{ "SIGNUP.AlreadHaveAccount" | translate }}'>
        <p class="text-center or-text">
          {{ "SIGNUP.AlreadHaveAccount" | translate }}
        </p>
      </div>
      <div>
        <div class="signuptxt cursor-pointer" (click)="goToLogin(false)">
          {{ "SIGNUP.SIGNIN" | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="signupSuccess" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered">
    <div
      class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
      <div class="modal-body relative pt-3">
        <div class="text-center mt-3">
          <div>
            <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
          </div>
          <h5 class="fw-bold q-form-heading mt-3">
            {{ "SUCESSMESSAGE.Congratulations" | translate }}
          </h5>
          <p class="my-3">
            {{ "SUCESSMESSAGE.SUccessFullySignup" | translate }}
          </p>
          <button class="submit-btn bg-orgclr w-auto mb-3" type="button" (click)="goToLogin(false)">
            {{ "SIGNUP.SIGNIN" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>